import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b79479fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-selected"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "tag is-light",
  "data-unit": "toc-2d-result-count"
}
const _hoisted_5 = ["aria-selected"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cube" })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "tag is-light",
  "data-unit": "toc-3d-result-count"
}

import { computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'TocContentTabs',
  setup(__props) {

const store = useStore()

const activeContent = computed(() => store.state.content.toc.activeContent)
const hasThreeDContent = computed(() => store.state.content.toc.threeDModelSnapshots.length > 0)
const hasTwoDContent = computed(() => store.state.content.toc.items.length > 0)
const hasQuery = computed(() => Boolean(store.state.content.toc.query?.trim()))
const threeDResultCount = computed(() => store.state.content.toc.threeDResultCount || 0)
const twoDResultCount = computed(() => store.state.content.toc.twoDResultCount || 0)

function selectContent (activeContent: '2d' | '3d') {
  store.dispatch('content/updateTocActiveContent', activeContent)
}

return (_ctx: any,_cache: any) => {
  return (hasTwoDContent.value && hasThreeDContent.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "buttons has-addons toc-content-tabs",
        role: "tablist",
        "aria-label": _ctx.$t('content')
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-small", { 'is-primary': activeContent.value === '2d' }]),
          "aria-selected": activeContent.value === '2d',
          "data-unit": "toc-2d-content-tab",
          role: "tab",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectContent('2d')))
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('twoDContent')), 1),
          (hasQuery.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(twoDResultCount.value), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2),
        _createElementVNode("button", {
          class: _normalizeClass(["button is-small", { 'is-primary': activeContent.value === '3d' }]),
          "aria-selected": activeContent.value === '3d',
          "data-unit": "toc-3d-content-tab",
          role: "tab",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectContent('3d')))
        }, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('threeD.content')), 1),
          (hasQuery.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(threeDResultCount.value), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_5)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})